<one-card [notPadding]="true">

  <div class="fh-table-header">
    <span class="fh-table-title">List of companies</span>
    <one-input
      #searchInput
      class="fh-search"
      label="Search by Company ID, TAX ID or name"
      type="search"
      autocomplete="off"
      (input)="onSearch($event)"
    ></one-input>
  </div>

  <div class="fh-divider"></div>

  <div class="fh-filters">
    <div class="fh-filters-left">
      <div class="fh-filter-item">
        <one-select
          #typeSelect
          class="one-select standard"
          [config]="selectConfigNoSearch"
          [multiple]="true"
          [dataSource]="typeDataSource"
          label="Company type"
          size="small"
          (selectionChanged)="onTypeChange(typeSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #statusSelect
          class="one-select standard"
          [config]="selectConfigNoSearch"
          [multiple]="true"
          [dataSource]="statusDataSource"
          label="Status"
          size="small"
          (selectionChanged)="onStatusChange(statusSelect.control.value)"
        ></one-select>
      </div>
      <div class="fh-filter-item">
        <one-select
          #ownerSelect
          class="one-select standard"
          [config]="selectConfig"
          [multiple]="true"
          [dataSource]="ownerDataSource"
          label="Owner"
          size="small"
          (selectionChanged)="onOwnerChange(ownerSelect.control.value)"
        ></one-select>
      </div>
    </div>
    <div class="fh-filters-right">
      <label class="fh-test-checkbox fh-test-checkbox--disabled">
        <input
          type="checkbox"
          class="rp-switch"
          [(ngModel)]="filterIsTest"
          (change)="onTestToggle()"
          disabled
        >
        <span>Test companies</span>
      </label>
    </div>
  </div>

  <one-dynamic-table *ngIf="tableData" [tableData]="tableData"></one-dynamic-table>

</one-card>

<ng-template #truncatedTextTemplate let-value="value" let-maxLength="maxLength">
  <span
    class="fh-truncated-text"
    [appCustomTooltip]="value"
    tooltipPosition="top"
    [showToolTip]="value.length > maxLength"
  >{{ value.length > maxLength ? value.slice(0, maxLength) + '…' : value }}</span>
</ng-template>

<ng-template #statusTemplate let-label="label" let-code="code">
  <span class="fh-status-badge" [ngClass]="'fh-status--' + code">{{ label }}</span>
</ng-template>

<ng-template #ownerTemplate let-value="value" let-owners="owners" let-maxLength="maxLength">
  <button
    *ngIf="value === MULTIPLE_OWNERS"
    type="button"
    class="fh-owner-link"
    (click)="openOwnersDialog(owners)"
  >{{ value }}</button>
  <span
    *ngIf="value !== MULTIPLE_OWNERS"
    class="fh-truncated-text"
    [appCustomTooltip]="value"
    tooltipPosition="top"
    [showToolTip]="value.length > maxLength"
  >{{ value.length > maxLength ? value.slice(0, maxLength) + '…' : value }}</span>
</ng-template>

<ng-template #actionsTemplate let-id="id" let-status="status">
  <div class="fh-row-actions">
    <button
      class="fh-row-actions__btn"
      type="button"
      (click)="viewCompany(id, status)"
      title="View company"
    >
      <span class="one-icon-open-eyes"></span>
    </button>
  </div>
</ng-template>
